<template>
	<span>
		<slot v-bind:formatValue="formatValue" v-bind:value="currentTime">
			{{formatValue}}
		</slot>
	</span>
</template>
<script>
	export default {
		name: "CountDown",

		props: {
			value: {
				type: Number,
				default: 0
			},
		},

		data(){
			return {
				counting: false,
				pausing: false,
				lastCount: 0,
				currentTime: 0,
				timer: null
			}
		},

		computed: {
			formatValue(){
				return this.currentTime + "s"
			}
		},

		methods: {
			countdown(total){
				var vm = this

				if(total <= 0){
					return
				}

				// 计时开始
				this.$emit("count-start", total)
				this.currentTime = total

				this.timer = window.setInterval(function(){
					vm.currentTime--

					// 倒计时结束
					if(vm.currentTime < 0){
						window.clearInterval(vm.timer)
						vm.$emit("input", 0)
						vm.currentTime = 0
						vm.counting = false
						vm.$emit("count-end", vm.currentTime)
					}else{
						// 同步时间
						vm.$emit("input", vm.currentTime)
					}
				}, 1000)
			},

			// 暂停，停止计时，可以恢复
			pause(){
				if(this.timer){
					window.clearInterval(this.timer)
				}
				this.counting = false
				this.pausing = true
			},

			// 开始，从原点开始/从暂停处开始
			start(){
				if(this.counting){
					return
				}
				
				var total = this.lastCount

				this.counting = true

				// 暂停中恢复
				if(this.pausing){
					this.pausing = false
					total = this.currentTime
				}

				this.countdown(total)
			},

			// 停止，回到原点，静止不动
			stop(){
				if(this.timer){
					window.clearInterval(this.timer)
				}

				this.currentTime = this.lastCount
				this.$emit("input", -1)
				this.counting = false
				this.pausing = false
			},

			// 重新开始，回到原点并重新计时
			restart(){
				this.stop()
				this.$nextTick(() => this.start())
			},
		},

		// 销毁前
		beforeDestroy(){
			if(this.timer){
				window.clearInterval(this.timer)
			}
		},

		watch: {
			value: {
				handler(val){
					// 重新计时
					if(val > 0 && !this.counting){
						this.lastCount = this.value

						return this.start()
					}

					if(val < 0){
						return this.stop()
					}
				},
				immediate: true
			}
		}
	}
</script>